import { Injectable, Inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { NavigationService } from '..';
import { IdentityService } from '../../identity';

@Injectable()
export class ActivateGuard  {

	constructor(private identityService: IdentityService,
		private navService: NavigationService) {

		return;
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		//if (!this.identityService.isReady || this.identityService.isLoggedIn) {
		//	return true;
		//}
		//else {
		//	this.navService.gotoLogin(state.url);
		//	return false;
		//}

		return true;
	}

}
